import React from 'react';
import { Typography, TypographyProps } from '@material-ui/core';
import { useElementSize } from '../../utils';

type TypographyCustomProps = Omit<TypographyProps, 'ref'>;

type Props = {
  length?: number;
  width?: number;
};

/**
 * Truncate and display a value targeting passed in width of the parent.
 * @param value value to truncate and display
 * @param width parent container width(in px recommended to use `useElementSize`). Will override style width.
 * @see {@link useElementSize}
 */
export function TruncatedContentDisplay({
  children,
  width = 20,
  style,
  ...props
}: Props & TypographyCustomProps) {
  return (
    <Typography
      {...props}
      noWrap
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...style,
        width,
      }}
    >
      {children}
    </Typography>
  );
}
